<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="ch00_fm04_copy"></a><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London<br/><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copy">© 2010 by New York University<br/>All rights reserved</p>
<p class="copy">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Knight, Frederick C.<br/>Working the diaspora : the impact of African labor on the Anglo-American world, 1650–1850 / Frederick C. Knight.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN-13: 978–0–8147–4818–3 (cl : alk. paper)<br/>ISBN-10: 0–8147–4818–x (cl : alk. paper)<br/>1. Slave labor—America—History. 2. Agricultural laborers—<br/>America—History. 3. Africans—America—History.<br/>4. Blacks—America—History. 5. Agriculture—America—History.<br/>6. African diaspora. I. Title.<br/>HD4865.A45K65           2009<br/>331.11’7340970903—dc22             2009026860</p>
<p class="copy">New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="copy">Manufactured in the United States of America<br/>10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copy.vue?5f5d20d0